import { render, staticRenderFns } from "./LabelMenu.vue?vue&type=template&id=128e55d2"
import script from "./LabelMenu.vue?vue&type=script&lang=js"
export * from "./LabelMenu.vue?vue&type=script&lang=js"
import style0 from "./LabelMenu.vue?vue&type=style&index=0&id=128e55d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports